__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-08-26-1787743537-stable-dev/";